import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, CheckCircle, Users, Package, Rocket } from 'lucide-react';

const pathwaySteps = [
  {
    title: 'Campus2Container',
    description: '6-week free training program',
    icon: GraduationCap,
    color: 'blue'
  },
  {
    title: 'Export Readiness',
    description: 'Complete certification & assessment',
    icon: CheckCircle,
    color: 'green'
  },
  {
    title: 'Mentorship',
    description: 'Connect with industry experts',
    icon: Users,
    color: 'purple'
  },
  {
    title: 'Sample Shipment',
    description: 'Practice with real export process',
    icon: Package,
    color: 'orange'
  },
  {
    title: 'Real Export',
    description: 'Launch your export business',
    icon: Rocket,
    color: 'red'
  }
];

const C2CSuccessPathway = () => {
  return (
    <section id="success-pathway" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Your Success Pathway
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            From campus to container - your journey to export success
          </motion.p>
        </div>

        <div className="relative">
          {/* Desktop Timeline */}
          <div className="hidden lg:block">
            <div className="flex items-center justify-between mb-8">
              <div className="flex-1 h-1 bg-gray-200 relative">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: '100%' }}
                  viewport={{ once: true }}
                  transition={{ duration: 2, delay: 0.5 }}
                  className="h-full bg-gradient-to-r from-blue-500 to-red-500"
                />
              </div>
            </div>
            
            <div className="flex justify-between">
              {pathwaySteps.map((step, index) => (
                <motion.div
                  key={step.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="flex flex-col items-center max-w-xs"
                >
                  <div className={`w-20 h-20 bg-${step.color}-100 rounded-full flex items-center justify-center mb-4 shadow-lg`}>
                    <step.icon className={`h-10 w-10 text-${step.color}-600`} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-center text-sm">
                    {step.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Mobile Timeline */}
          <div className="lg:hidden space-y-8">
            {pathwaySteps.map((step, index) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center space-x-4"
              >
                <div className={`w-16 h-16 bg-${step.color}-100 rounded-full flex items-center justify-center flex-shrink-0`}>
                  <step.icon className={`h-8 w-8 text-${step.color}-600`} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default C2CSuccessPathway;